import { useCallback, useContext } from 'react';
import { AjaxContext } from 'commons-ui';
import { BULK_QUERY_LABELS } from '../../../constants';
import { API_ENDPOINTS } from '../constants';
import {
	PageDetails,
	ERROR_MESSAGES,
	ListSuspiciousTransactionsRequest,
	StartSuspiciousTransactionsRequest,
	ListSuspiciousTransactionsResponse,
	StartSuspiciousTransactionsResponse
} from './types';

export default function useSuspiciousService() {
	const { postData } = useContext(AjaxContext);

	const listRequests = useCallback(
		async ({ pageDetails }: { pageDetails: PageDetails }) => {
			const body: ListSuspiciousTransactionsRequest = {
				pageNo: pageDetails.pageNo,
				pageSize: pageDetails.pageSize,
				queryLabel: BULK_QUERY_LABELS.GET_SUSPICIOUS_TRANSACTIONS
			};
			const resp = await postData({ endpoint: API_ENDPOINTS.LIST_REQUESTS, body });
			const respData: ListSuspiciousTransactionsResponse = resp?.data;
			if (!respData?.success) {
				throw new Error(respData?.message || ERROR_MESSAGES.FETCH_REQUESTS_FAILED);
			}
			const { requests = [], totalCount = 0 } = respData.data || {};
			const requestsWithId = requests.map((row: any, index: number) => ({ ...row, id: index + 1, index: index + 1 }));
			return {
				rowCount: totalCount,
				data: requestsWithId
			};
		},
		[postData]
	);

	const createRequest = useCallback(
		async (payload: StartSuspiciousTransactionsRequest) => {
			const resp = await postData({ endpoint: API_ENDPOINTS.CREATE_REQUEST, body: payload });
			const respData: StartSuspiciousTransactionsResponse = resp?.data;
			if (!respData?.success) {
				throw new Error(respData?.message || ERROR_MESSAGES.CREATE_REQUEST_FAILED);
			}
			return respData.requestId;
		},
		[postData]
	);

	return { listRequests, createRequest };
}
